import {Component, EventEmitter, Input, Output} from '@angular/core';
import {OrderDetailsPayment} from '../../models/order-details/order-details-payment.class';
import {Payment} from '../../models/payment.class';
import {PaymentService} from '../../services/payment-service/payment.service';
import {PaymentStatus} from '../../models/payment-status.enum';

@Component({
    selector: 'app-order-payment-table',
    templateUrl: './order-payment-table.component.html',
    styleUrls: ['./order-payment-table.component.scss'],
    standalone: false
})
export class OrderPaymentTableComponent {

    constructor(private paymentService: PaymentService) {
    }

    @Input() orderDetailsPayments: OrderDetailsPayment[];
    @Output() paymentStatusUpdated: EventEmitter<any> = new EventEmitter();

    private refreshPaymentStatuses = [PaymentStatus.OPEN, PaymentStatus.EXPIRED];

    paymentMethodClassMap: { [key: string]: string } = {
        IDEAL: 'cm-payment-ideal',
        BANCONTACT: 'cm-payment-bancontact',
        SOFORT_BANKING: 'cm-payment-sofort',
        MASTER_CARD: 'cm-payment-mastercard',
        VISA_CARD: 'cm-payment-visa',
        BANK_TRANSFER: 'cm-payment-bank-transfer',
        IN_THREE: 'cm-payment-in3',
        CASH: 'cm-icon-money',
        APPLE_PAY: 'cm-payment-apple-pay',
        GOOGLE_PAY: 'cm-payment-google-pay-vignet',
    };

    isRefreshableStatus(paymentStatus: PaymentStatus): boolean {
        return this.refreshPaymentStatuses.includes(paymentStatus);
    }

    updatePaymentStatus(payment: Payment) {
        if (payment.status !== PaymentStatus.OPEN && payment.status !== PaymentStatus.EXPIRED) {
            return;
        }

        this.paymentService.checkPaymentStatus(payment.id).subscribe(_ => {
            this.paymentStatusUpdated.emit();
        });
    }

    getPaymentMethodSpecificClass(method: string): string {
        const key = method.toUpperCase();
        return this.paymentMethodClassMap[key] || '';
    }
}
